import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/user.context";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAnalyticsAccess } from "../../../api/analyticsAccess";

const ReportsList: React.FC = () => {
  const navigate = useNavigate();
  const { appMenu } = useAuth();
  const [t] = useTranslation();
  const analyticsAccess = useAnalyticsAccess();

  const hasFeature = (feature: string) => {
    return true;
  };

  return (
    <Container>
      <Title>{t("REPORTS")}</Title>
      <ReportsContainer>
        {analyticsAccess.state === "allowed" && (
          <ReportCard onClick={() => navigate("/analytics/dashboard")}>
            <CardTitle>{t("DD_TITLE")}</CardTitle>
            <CardDescription>{t("DD_DESCRIPTION")}</CardDescription>
          </ReportCard>
        )}

        <ReportCard onClick={() => navigate("/utilities/reports/revenue-reports")}>
          <CardTitle>{t("HISTORIC_REVENUE_PER_REGION")}</CardTitle>
          <CardDescription>{t("HISTORIC_REVENUE_DESCRIPTION")}</CardDescription>
        </ReportCard>

        {hasFeature("utils.reports.estimated_instance_monthly_revenue") && (
          <ReportCard onClick={() => navigate("/utilities/reports/estimated-instance-revenue")}>
            <CardTitle>{t("ESTIMATED_INSTANCE_REVENUE")}</CardTitle>
            <CardDescription>{t("ESTIMATED_INSTANCE_DESCRIPTION")}</CardDescription>
          </ReportCard>
        )}

        {hasFeature("utils.reports.yearly_revenue") && (
          <ReportCard onClick={() => navigate("/utilities/reports/yearly-revenue")}>
            <CardTitle>{t("YEARLY_REVENUE_REPORT")}</CardTitle>
            <CardDescription>{t("YEARLY_REVENUE_DESCRIPTION")}</CardDescription>
          </ReportCard>
        )}
      </ReportsContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 24px;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette[900]};
  margin-bottom: 24px;
`;

const ReportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 500px;
`;

const ReportCard = styled.div`
  background: ${({ theme }) => theme.palette[10]};
  border: 1px solid ${({ theme }) => theme.palette[20]};
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: ${({ theme }) => theme.palette[50]};
  }
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette[900]};
  margin-bottom: 8px;
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.palette[700]};
  margin: 0;
  line-height: 1.5;
`;

export default ReportsList;
